import { PossessedScatterSymbol } from "./PossessedScatterSymbol";
import {
    PossessedSymbol,
    PossessedSymbolStates,
    PossessedSymbolCreateArgs
} from "./PossessedSymbol";
import { PossessedActivatorSymbol } from './PossessedActivatorSymbol';
import {PossessedWildSymbol} from "./PossessedWildSymbol";
import {PossessedInfectiousSymbol} from "./PossessedInfectiousSymbol";


export class PossessedSymbolFactory {

    public static createSymbol(name:string, reelID:number, reelPosition:number, initialState:PossessedSymbolStates = PossessedSymbolStates.NORMAL):PossessedSymbol {
        const createArgs:PossessedSymbolCreateArgs = {
            name: name,
            initialState: initialState,
            reelID: reelID,
            reelPosition: reelPosition,
        };
        let symbol:PossessedSymbol;
        switch(name) {
            case "S":
                symbol = new PossessedScatterSymbol(createArgs);
                break;

            case "XA":
                symbol = new PossessedActivatorSymbol(createArgs);
                break;


            case "XIN":
                symbol = new PossessedInfectiousSymbol(createArgs);
                symbol.initDefaultSymbolSprites(createArgs.initialState);
                break;

            case "W":
                symbol = new PossessedWildSymbol(createArgs);
                symbol.initDefaultSymbolSprites(initialState);
                break;

            default:
                symbol = new PossessedSymbol(createArgs);
                symbol.initDefaultSymbolSprites(initialState);
                break;
        }
        return symbol;
    }
}